import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { BeforeAfter } from './components/BeforeAfter';
import { InProgress } from './components/InProgress';
import { Videos } from './components/Videos';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-light font-sans text-primary selection:bg-accent selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <Process data-id="element-6" />
        <BeforeAfter data-id="element-7" />
        <InProgress data-id="element-8" />
        <Videos data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}